import React from 'react';
import styles from './headerPerson.module.css';
import Breadcrumbs from "../breadcrumbs/breadcrumbs";
import {PersonFull} from "../../types/personTypes";
import {NavLink} from "react-router-dom";
import HeaderMenu from "../headerMenu/headerMenu";

interface HeaderPersonProps {
	person: PersonFull;
	menu?: any;
}

const HeaderPerson: React.FC<HeaderPersonProps> = ({ person, menu }) => {

	return (
		<header className={styles.header}>
			<Breadcrumbs />
			<div className={styles.header_profile}>
				<ul className={styles.profile_content}>
					<li>
						<h1>
							{person.nick_name ? (
								<span>{person.nick_name}</span>
							) : (
								<>
									<span>{person.first_name}</span>
									<span>{person.last_name}</span>
								</>
							)}
						</h1>
					</li>
					<li className={styles.border}>
						<ul className={styles.profile_info}>
							<li>{person.position}</li>
								<ul>
									<li>
										<img
											src={person.club_logo}
											alt={person.club_name}
											className={styles.clubLogo}
										/>
									</li>
									<li className={styles.playerNumber}>
										{person.number}
									</li>
									<li>
										<p>{person.club_name}</p>
										<p className={styles.text__secondary}>
											{person.club_city}
										</p>
									</li>
								</ul>
							<li className={styles.text__accent}>Состав команды &darr;</li>
						</ul>
					</li>
					<li>
						<HeaderMenu menu={menu}/>
					</li>
				</ul>
				{person.photo &&
				<div className={styles.header_profile__img_container}>
					<img
						src={person.photo}
						alt={`${person.first_name} ${person.last_name}`}
						className={styles.header_profile__img}
					/>
				</div>
				}

			</div>
		</header>
	);
}

export default HeaderPerson;
